import React from 'react';
import { LinkEvaluator } from '../../../utils/LinkEvaluator';
import Marquee from 'react-fast-marquee';
import { styled } from 'linaria/react';
import Image from '@jetshop/ui/Image';
import { theme } from '../../Theme';

const StartPageMarqueeWrapper = styled('div')`
    width: 100%;
    overflow: hidden;
    position: relative;
    height: auto
    background: #4D4D4D;
    padding: 10px 0;
    
`;

export const StartPageMarquee = ({ children }) => {
  return (
    <StartPageMarqueeWrapper>
      <Marquee pauseOnHover={true}>{children}</Marquee>
    </StartPageMarqueeWrapper>
  );
};

const ImageWrapper = styled('div')`
  height: 60px;
  aspect-ratio: ${(props) => props.aspect};
  margin-right: 50px;

  ${theme.below.md} {
    height: 40px;
    margin-right: 30px;
  }

  img {
    filter: contrast(3) brightness(0) invert(1);
    /* Extra boost for making it white no matter the input */
    mix-blend-mode: lighten;
  }
`;

export const StartPageMarqueeItem = ({
  image,
  link,
  imageAspectRatio = { value: '16:9' },
}) => {
  const aspectAdjuster = (aspect) => {
    const aspectParts = aspect.split(':');
    const width = parseInt(aspectParts[0]);
    const height = parseInt(aspectParts[1]);
    return `${width} / ${height}`;
  };
  return (
    <LinkEvaluator link={link}>
      <ImageWrapper aspect={aspectAdjuster(imageAspectRatio.value)}>
        <Image
          src={image?.value}
          alt={''}
          fillAvailableSpace={true}
          sizes={[
            1 / 2,
            1 / 3,
            1 / 4,
            1 / 5,
            1 / 6,
            1 / 7,
            1 / 8,
            1 / 9,
            1 / 10,
          ]}
        />
      </ImageWrapper>
    </LinkEvaluator>
  );
};
